const SubAbasNotasVersao = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/maisopcoes/notas/ficha/${id}/dadosgerais`,
  },
  //   {
  //     label: 'Produtos',
  //     rota: `/daf/produtosdaf/denominacoes/ficha/${id}/produtos`,
  //   },
];

export default SubAbasNotasVersao;
